export var PACKAGE_VERSION = "3.0.7696.0 (15675c65)";
export var THEME = "polaris";